/**
 * 赛事提醒
 */
import React, { useEffect, useState } from 'react';
import { Modal, Table, Button } from 'antd';
import { ColumnProps } from 'antd/es/table';
import intl from 'react-intl-universal';

import getRandomId from '@/utils/uuid';
import { queryGuestGameList } from '@/api/guest';
import { getPortal } from '@/components/PortalContext';

import styles from './index.module.scss';

interface GuestItemInfo {
  wyuId: string;
}

interface IRecord {
  uniqueId: string;
  name: string; // 客户名称
  startTime: number; // 比赛时间
  yooPlayName: string; // 赛事名称
}

interface IProps {
  guestList: GuestItemInfo[];
  onClose: () => void;
}

const Index: React.FC<IProps> = (props) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [tableData, setTableData] = useState<IRecord[]>([]);
  const { onClose } = props;

  const tableColumn: ColumnProps<IRecord>[] = [
    { title: intl.get('reservation_cmp_ygp_game_table_column_guest'), dataIndex: 'name' },
    { title: intl.get('reservation_cmp_ygp_game_table_column_game'), dataIndex: 'yooPlayName' },
    {
      title: intl.get('reservation_cmp_ygp_game_table_column_time'),
      dataIndex: 'startTime',
      width: 180,
    },
  ];

  //
  const closeModal = () => {
    setModalVisible(false);
    onClose();
  };

  const getGameList = async () => {
    try {
      const { guestList } = props;
      // 过滤用户id
      const filterIdMap = {};
      const guestIdList: string[] = [];
      guestList.forEach((item) => {
        const itemId = item.wyuId;
        if (itemId && !filterIdMap[itemId]) {
          guestIdList.push(`wyuids=${itemId}`);
          filterIdMap[itemId] = true;
        }
      });
      if (guestIdList.length) {
        const res = await queryGuestGameList(guestIdList.join('&'));
        const gameList: IRecord[] = res.data || [];
        if (gameList.length) {
          setModalVisible(true);
          setTableData(
            gameList.map((item) => {
              return {
                ...item,
                uniqueId: getRandomId(),
              };
            }),
          );
        }
      }
    } catch (e) {
      //
    }
  };

  useEffect(() => {
    getGameList();
  }, []);

  return (
    <Modal
      wrapClassName={styles.modalWrapper}
      title={intl.get('reservation_cmp_ygp_game_title')}
      width={640}
      centered
      destroyOnClose
      maskClosable={false}
      open={modalVisible}
      onCancel={closeModal}
      footer={
        <Button type="primary" onClick={closeModal}>
          {intl.get('app_confirm_confirm_btn')}
        </Button>
      }
    >
      <div>
        <div className={styles.promptText}>{intl.get('reservation_cmp_ygp_game_content')}</div>
        <Table
          rowKey="uniqueId"
          columns={tableColumn}
          scroll={{ x: 'max-content', y: 340 }}
          dataSource={tableData}
          pagination={false}
        />
      </div>
    </Modal>
  );
};

const showGamePrompt = (list: GuestItemInfo[]) => {
  if (list && list.length) {
    let portalId;
    const closePortal = () => {
      setTimeout(() => {
        if (portalId) {
          getPortal().removePortalNode(portalId);
        }
      }, 3000);
    };
    portalId = getPortal().renderPortalNode(() => <Index guestList={list} onClose={closePortal} />);
  }
};

export default showGamePrompt;
